// title
// image
// image title
// image description

import { Box, Link, Typography } from "@mui/material";
import { PageContainer } from "./Pages";
import SectionTitle from "./SectionTitle";
import ItemTitle from "./ItemTitle";

export default function ImageDesc({ title, items, link }) {
    const ImageComponent = ({img, itemLink}) => {
        return (
            <Link
                href={itemLink}
                sx={{
                    width: {
                        xs: '100%',
                        sm: '100%',
                        md: '50%',
                        lg: '50%',
                    },
                    '&:hover':{
                        textDecoration: 'none',
                    },
                }}
            >

                <Box
                    component={"img"}
                    src={img}
                    alt="img"
                    sx={{
                        borderRadius: '20px',
                        objectFit: 'cover',
                        boxShadow: 10,
                        '&:hover':{
                            cursor: 'pointer'
                        }
                    }}
                >
                </Box>
            </Link>
        )
    }   
    const TextComponent = ({title, description, itemLink}) => {
        return (
            <Box
                sx={{ 
                    width: {
                        xs: '100%',
                        sm: '100%',
                        md: '50%',
                        lg: '50%',
                    },
                    height: '100%',
                    padding: '10px',
                }}
                >
                
                {title && <ItemTitle title={title} link={itemLink}/>}
                <Typography
                    sx={{
                            textAlign: {
                                xs: 'center',
                                sm: 'center',
                                md: 'justify',
                            },
                            textIndent: {
                                md: '80px'
                            }
                    }}
                >

                    {description && <p>{description}</p>}
                </Typography>
            </Box>
        )
    }   


    return (
        <PageContainer>
            <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                gap: 4
            }}
            >
            <SectionTitle title={title} link={link}/>
                {
                    items?.map((item, index) => {
                        const even = index % 2 === 0;
                    return (
                        
                        <Box key={index} >
                            <Box
                                sx={{
                                    display:{
                                            xs: 'none',
                                            sm: 'none',
                                            md: 'flex',
                                            lg: 'flex'
                                        },
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                }}
                            >
                                {even && <ImageComponent img={item?.img} itemLink={item?.link}

                                />}
                                <TextComponent title={item?.title} description={item?.description} itemLink={item?.link}/>
                                {!even && <ImageComponent img={item?.img} itemLink={item?.link}/>}
                            </Box>
                            <Box
                                sx={{
                                    display:{
                                            xs: 'flex',
                                            sm: 'flex',
                                            md: 'none',
                                            lg: 'none'
                                        },
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                }}
                            >   
                                <ItemTitle title={item?.title} link={item?.link} />
                                <ImageComponent img={item?.img} itemLink={item?.link}/>
                                <TextComponent description={item?.description} itemLink={item?.link}/>
                            </Box>
                        </Box>
                    )
                })
                }
            </Box>
        </PageContainer>
    );
}